import type { ReactElement } from 'react';
import { monthDay } from 'utils/dateTimes';

import type ISku from 'models/ISku';
import MenuItem from 'models/MenuItem';

import SkuGallery from 'components/shared/SkuGallery';

type Props = {
  skus: ISku[];
  menuDate: Date;
};

function PlanRecipes({ skus, menuDate }: Props): ReactElement {
  return (
    <div className="c-pricing-menu c-pricing-menu">
      <div className="l-container">
        <div aria-label="View this week's menu">

          <div className="c-pricing-menu__title">
            <h2 className="c-pricing__step-title c-heading--brand-5 c-heading--no-margin" tabIndex={-1}>
              3 - Checkout and pick some meals!
            </h2>

            <div className="u-text--sm u-text--info">
              <em>
                These meals are on the menu the week of&nbsp;
                {monthDay(menuDate)}
              </em>
            </div>
          </div>

          <div className="c-pricing-menu__recipes">
            <SkuGallery
              showFavoritesWidget={false}
              items={skus.map((sku) => new MenuItem({
                sku,
                quantity: 1,
              }))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanRecipes;
